function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { FIELD_TYPES } from "constants/template-field-type";
import AssetFieldsConfig from "components/core/asset/fields-config.js";
import PersonalTextualInfoConfig from "../person-textual-info/fields-config";
const { image } = AssetFieldsConfig;
const { color } = PersonalTextualInfoConfig, selectedTextualInfoFields = _object_without_properties(PersonalTextualInfoConfig, [
    "color"
]);
export default {
    autoplay: {
        type: FIELD_TYPES.NESTED,
        label: "Auto-play definitions",
        fields: {
            shouldAutoPlay: {
                type: FIELD_TYPES.BOOLEAN,
                label: "Should auto-play reviews"
            },
            interval: {
                type: FIELD_TYPES.TEXT,
                label: "Interval (number of milliseconds)"
            }
        }
    },
    reviews: {
        type: FIELD_TYPES.MULTIPLE_NESTED,
        label: "Reviews",
        maxLimit: 15,
        nestedConfig: {
            type: FIELD_TYPES.NESTED,
            fields: _object_spread_props(_object_spread({
                quote: {
                    type: FIELD_TYPES.TEXT,
                    label: "Quote",
                    textArea: true,
                    translatable: true
                }
            }, selectedTextualInfoFields), {
                companyLogo: _object_spread_props(_object_spread({}, image), {
                    label: "Company Logo"
                }),
                customerImage: _object_spread_props(_object_spread({}, image), {
                    label: "Customer Image",
                    labelDescription: "Please select an image with 100x100 dimensions."
                })
            })
        }
    }
};
